import {
  Icon,
  Inline,
  Link,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';

import { ReactComponent as OmniprotectLogo } from '../../../assets/omniprotect.svg';

const LEARN_MORE_LINK =
  'https://help.omnipresent.com/en/articles/9418855-understanding-misclassification-risk-and-how-omniprotect-can-help';

const OMNIPROTECT_DESCRIPTION =
  'OmniProtect shields you from legal liability from contractor misclassification, covering penalties and indemnities, legal costs, and much much more.';

const CoverageItem = ({ coverageItem }: { coverageItem: string }) => (
  <Inline align="center" gap="8">
    <Icon icon="CircleCheck" color="positive" size="24" />
    <Typography as="span" size="14" color="subtle">
      {coverageItem}
    </Typography>
  </Inline>
);

export const ContractorLiabilityShieldDescription = () => {
  return (
    <Stack gap="24">
      <Inline align="center" justify="space-between">
        <OmniprotectLogo />
        <Link
          size="14"
          icon="ExternalLink"
          target="_blank"
          to={LEARN_MORE_LINK}
        >
          Learn more
        </Link>
      </Inline>
      <Typography as="span" size="14" color="subtle">
        {OMNIPROTECT_DESCRIPTION}
      </Typography>

      <Stack p="16" radius="s" border="subtle" bg="page">
        <Typography as="span" size="14" weight="medium">
          Coverage includes
        </Typography>
        <Inline gap="16" justify="space-between">
          <Stack gap="8">
            <CoverageItem coverageItem="Penalties and indemnities" />
            <CoverageItem coverageItem="Legal costs up to $25k" />
            <CoverageItem coverageItem="Penalties from tax authorities" />
          </Stack>
          <Stack gap="8">
            <CoverageItem coverageItem="3rd party indemnity up to $100k" />
            <CoverageItem coverageItem="$100k limit per contractor" />
            <CoverageItem coverageItem="Client limit of $1M" />
          </Stack>
        </Inline>
      </Stack>
    </Stack>
  );
};
